export const API_URLS = {
  rssFeed: "https://epzykckrwiedjpgcpzqi.supabase.co/functions/v1/feed",
  flightSearch: "https://flightsearch-api.voopter.com.br/createSearchIntent",
  flightSearch_dev:
    "https://flightsearch-api-staging.voopter.com.br/createSearchIntent",
  flightSearch_local: "http://localhost:3000/createSearchIntent",
  alerts: "https://alerts-api.voopter.com.br",
  alerts_dev: "https://alerts-api-staging.voopter.com.br",
  trackingSearchWebhook:
    "https://voopter-n8n.oanhms.easypanel.host/webhook/voopter-search-635aab52",
  trackingSearchEndWebhook:
    "https://voopter-n8n.oanhms.easypanel.host/webhook/voopter-search-end-635aab52",
  trackingRedirectWebhook:
    "https://voopter-n8n.oanhms.easypanel.host/webhook/voopter-redirect-635aab52",
};
